import React from 'react';

import PropTypes from 'prop-types';

function PlayIcon2({ width = 12, height = 12, color = '#1B1C19', ...rest }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 10 12"
      fill="none"
      {...rest}
    >
      <path
        d="M10 6C10.0004 6.1567 9.9608 6.31083 9.88513 6.44741C9.80946 6.58398 9.70027 6.69835 9.56818 6.77939L1.38182 11.8641C1.2438 11.95 1.08572 11.9968 0.923908 11.9998C0.762096 12.0029 0.602417 11.962 0.461364 11.8814C0.321653 11.8021 0.205271 11.6865 0.124184 11.5463C0.0430974 11.4062 0.000233442 11.2467 0 11.0842V0.915821C0.000233442 0.753301 0.0430974 0.593777 0.124184 0.453653C0.205271 0.31353 0.321653 0.197865 0.461364 0.118552C0.602417 0.0379872 0.762096 -0.00288421 0.923908 0.000158269C1.08572 0.00320074 1.2438 0.0500469 1.38182 0.135858L9.56818 5.22061C9.70027 5.30165 9.80946 5.41602 9.88513 5.55259C9.9608 5.68917 10.0004 5.8433 10 6Z"
        fill={color}
      />
    </svg>
  );
}

PlayIcon2.propTypes = {
  color: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number,
};

export default PlayIcon2;
